import React, { useEffect } from 'react';
import { officialsList } from '../../ProData';
import { Helmet } from "react-helmet-async";
import { Sparkles } from 'lucide-react';
import { motion } from 'framer-motion';

export default function TeamOfficials() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="py-5" style={{ background: '#f8fafc', minHeight: '85vh' }}>
      <Helmet>
        <title>Academic Authorities &amp; Officials - Vidyajyoti College of Theology</title>
        <meta name="description" content="Academic Authorities, Chancellor, Vice-Chancellor, Rector, and Principal of Vidyajyoti College of Theology, Delhi." />
        <meta name="keywords" content="Vidyajyoti officials, Academic Authorities, Jesuit Rector Delhi, Vidyajyoti Principal" />
        <link rel="canonical" href="/about/officials" />
      </Helmet>

      <div className="container">
        {/* Page Header */}
        <div className="text-center mx-auto pb-4" style={{ maxWidth: '750px' }}>
          <div className="d-inline-flex align-items-center gap-2 px-3 py-1 rounded-pill mb-3" style={{ background: 'rgba(198, 146, 20, 0.12)', color: '#c69214', fontSize: '0.85rem', fontWeight: 600, border: '1px solid rgba(198, 146, 20, 0.25)' }}>
            <Sparkles size={14} /> College Governance
          </div>
          <h1 className="display-6 fw-bold mb-3" style={{ color: '#1a2b56', fontFamily: "'Outfit', sans-serif" }}>
            Academic Authorities
          </h1>
          <p className="lead text-muted" style={{ fontSize: '1.05rem', lineHeight: '1.7' }}>
            Meet the academic leadership, chancellor, rector, principal, and administrative authorities guiding the vision and ecclesial mission of Vidyajyoti Faculty of Theology.
          </p>
        </div>

        {/* Officials Grid */}
        <div className="row g-4 justify-content-center">
          {officialsList && officialsList.map((item, index) => (
            <motion.div
              key={index}
              className="col-sm-6 col-md-4 col-lg-4"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.08 }}
            >
              <div
                className="card h-100 border-0 shadow-sm rounded-4 p-4 text-center bg-white d-flex flex-column align-items-center"
                style={{
                  borderTop: '4px solid #1a2b56',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-6px)';
                  e.currentTarget.style.boxShadow = '0 12px 24px rgba(0,0,0,0.12)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.06)';
                }}
              >
                {/* Circular Portrait Frame */}
                <div
                  className="rounded-circle p-1.5 mb-3 shadow-sm"
                  style={{
                    background: 'linear-gradient(135deg, #1a2b56 0%, #c69214 100%)',
                    width: '140px',
                    height: '140px'
                  }}
                >
                  <img
                    src={item.avatarSrc}
                    alt={item.name}
                    className="rounded-circle w-100 h-100"
                    style={{ objectFit: 'cover' }}
                  />
                </div>

                <span className="badge px-2.5 py-1 rounded-pill mb-2" style={{ background: 'rgba(121, 3, 29, 0.08)', color: '#79031d', fontWeight: 600 }}>
                  {item.title || 'Official'}
                </span>

                <h4 className="fw-bold mb-1" style={{ color: '#1a2b56', fontSize: '1.15rem' }}>
                  {item.name}
                </h4>

                {item.subTitle && (
                  <p className="text-muted small mb-0 mt-1" style={{ lineHeight: '1.5' }}>
                    {item.subTitle}
                  </p>
                )}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}
